import { useState } from 'react'
import { KeyboardArrowDown } from '@mui/icons-material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useNavigate } from 'react-router-dom'
import { CONSTANTS } from '../../../Constants/Constant'
import { MUIGrid } from '../../Shared'
import AssetStateLabel from '../../Labels/AssetStateLabel'
import { getDateInFormat } from '../../../Helpers/Util'
import { IKeyValue } from '../../../Models/CommonListHeadingModal'
import style from '../../Molecule/Molecule.module.scss'
import headerStyles from './HeaderComponent.module.scss'
import { TooltipText } from '../../Shared/TooltipText/TooltipText'
import HeaderContent from './HeaderContent'

type HeaderValue = string | number | IKeyValue[]

interface HeaderComponentModal {
  headerLabel?: string
  status?: string
  type?: string
  layout?: string
  title?: string
  onDeleteIconClick?: () => Promise<void> | void | undefined
  headerData: {
    title: string
    value: HeaderValue
    type?: string
    maxCount?: number
    toolTipWidth?: string
  }[]
  headerEndTimeVisible?: boolean
  unfeaturedTime?: any
  isDeleted?: any
  dynamicHeaderFirstRow?: {
    title: string
    value: HeaderValue
    type?: string
    maxCount?: number
    toolTipWidth?: string
  }[]
}

export default function HeaderComponent({
  headerLabel,
  status = 'NA',
  type = 'NA',
  layout = 'NA',
  title = 'NA',
  onDeleteIconClick,
  headerData,
  headerEndTimeVisible = false,
  unfeaturedTime = 'NA',
  isDeleted,
  dynamicHeaderFirstRow,
}: HeaderComponentModal) {
  const [showDetails, setShowDetails] = useState(false)
  const navigate = useNavigate()
  const { DATE_N_TIME_FORMAT_SECONDS } = CONSTANTS

  const firstRowData = dynamicHeaderFirstRow

  const dynamicContentMuiGrid = (data: any) => {
    if (!data || data.length === 0) {
      return null
    }

    return data.map((header: any) => {
      const { title, value, type } = header

      return (
        <MUIGrid key={title} xs={6} lg={4}>
          <p className={`${headerStyles.headerDataWrapper}`}>
            <span style={{ fontWeight: '400', marginRight: '0.25rem' }} className={'col34'}>
              {`${title} :`}
            </span>
            <span className={`col36 ${style.header_value}`}>
              {typeof value === 'string' && type === 'date'
                ? getDateInFormat(value, DATE_N_TIME_FORMAT_SECONDS)
                : String(value || 'NA')}
            </span>
          </p>
        </MUIGrid>
      )
    })
  }
  return (
    <div className='asset__editor-header'>
      <div className='asset__editor-info'>
        <div style={{ position: 'relative' }}>
          <div
            aria-hidden={true}
            className='cursor-pointer mt-1'
            data-testid='asset_header_accordion'
            onClick={() => setShowDetails((prev) => !prev)}
          >
            {firstRowData && firstRowData.length > 0 ? (
              <div
                className={`d-flex justify-content-between align-items-center ${
                  headerStyles.widgetHeaderRow
                } ${style.asset_header_static} ${showDetails ? headerStyles.AccordionOpen : ''}`}
              >
                <MUIGrid container columnSpacing={2} rowSpacing={2} style={{ margin: 'auto' }}>
                  {dynamicContentMuiGrid(firstRowData)}
                  <div className={headerStyles.accordionIcon}>
                    {showDetails ? (
                      <KeyboardArrowUpIcon className='col33' />
                    ) : (
                      <KeyboardArrowDown className='col33' />
                    )}
                  </div>
                </MUIGrid>
              </div>
            ) : (
              <MUIGrid
                container
                className={`d-flex justify-content-between align-items-center ${
                  headerStyles.widgetHeaderRow
                } ${style.asset_header_static} ${showDetails ? headerStyles.AccordionOpen : ''}`}
              >
                <MUIGrid className={headerStyles.widgetHeaderCol}>
                  <p className='d-flex align-items-center' style={{ gap: '10px' }}>
                    <span className={`col34 ${headerStyles.widgetHeaderTitle}`}>
                      {`${headerLabel} Type`} :
                    </span>
                    <span className={`col36 capitalize ${style.f_12_w_600}`}>{type}</span>
                    <AssetStateLabel state={isDeleted ? 'Archived' : status} />
                  </p>
                </MUIGrid>
                <MUIGrid
                  className={`d-flex align-items-center ${headerStyles.widgetHeaderCol}`}
                  style={{ maxWidth: '50%', wordBreak: 'break-all', gap: '10px' }}
                >
                  <span className={`col34 ${headerStyles.widgetHeaderTitle}`}>Layout :</span>
                  <span className={`col36 ${style.header_value}`}>{layout || 'NA'}</span>
                </MUIGrid>
                <MUIGrid
                  className={`d-flex align-items-center ${headerStyles.widgetHeaderCol} ${headerStyles.widgetTitle}`}
                >
                  <span className={`col34 ${headerStyles.widgetHeaderTitle}`}>Title :</span>
                  <span className={`col36 ${style.w_600}`}>
                    <span className='d-flex align-items-center'>
                      {title ? <TooltipText text={title} length={60} /> : 'NA'}
                    </span>
                  </span>
                </MUIGrid>
                {headerEndTimeVisible && (
                  <div className='schedule_header'>
                    <div className='schedule_header_text'>
                      <span>Expiring On :</span>
                      <span>
                        {unfeaturedTime
                          ? getDateInFormat(unfeaturedTime, DATE_N_TIME_FORMAT_SECONDS)
                          : 'NA'}
                      </span>
                    </div>
                    <div className='schedule_header_icon' />
                  </div>
                )}
                <div className={headerStyles.accordionIcon}>
                  {showDetails ? (
                    <KeyboardArrowUpIcon className='col33' />
                  ) : (
                    <KeyboardArrowDown className='col33' />
                  )}
                </div>
              </MUIGrid>
            )}
          </div>
          {showDetails && (
            <HeaderContent
              headerData={headerData}
              navigate={navigate}
              onDeleteIconClick={onDeleteIconClick}
              isDeleted={isDeleted}
              status={status}
              layout={layout}
            />
          )}
        </div>
      </div>
    </div>
  )
}
